import { PublicCallback } from 'globals/types';
import * as AssistantAPI from 'core_main/api/assistant';
import * as AutomationsMetadataApi from 'core_main/api/automations_metadata';
import { maybeFetchCurrentTrackingToken } from 'core_main/api/tracking';
import { InitAssistantParameters } from 'core_main/api/assistant/types';
import { GetAutomationsMetadataApiResponse } from 'core_main/api/automations_metadata/types';
import {
  createInitAssistantCallbackResponse,
  normalizeAutomationMetadataAttributes,
  normalizeInitialMessages,
} from './helpers';
import { InitAssistantCallbackResponse } from './types';

export const initAssistant = (
  params: InitAssistantParameters,
  cb?: PublicCallback,
): Promise<InitAssistantCallbackResponse> => {
  const { aiAgentTeamId } = params;

  return maybeFetchCurrentTrackingToken()
    .then(() => {
      if (aiAgentTeamId) {
        return AutomationsMetadataApi.fetchAutomationsMetadata();
      }

      return AssistantAPI.initAssistant(params);
    })
    .then((res: GetAutomationsMetadataApiResponse) => {
      let callbackData;

      if (aiAgentTeamId) {
        const automationMetadata = res?.data?.find((automationMetadata) => {
          return (
            automationMetadata.attributes.liveAutomationId === aiAgentTeamId
          );
        });

        const attributes = automationMetadata?.attributes;
        const initialMessages = attributes?.proactive?.chat?.messages;

        if (!attributes || !initialMessages?.length)
          return Promise.reject(
            new Error('Proactive messages not found for AI Agent Team'),
          );

        callbackData = {
          attributes: normalizeAutomationMetadataAttributes(attributes),
          initialMessages: normalizeInitialMessages(initialMessages),
        };
      } else {
        callbackData = res.data;
      }

      const callbackResponse =
        createInitAssistantCallbackResponse(callbackData);
      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
      return callbackResponse;
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      throw new Error(error);
    });
};
